import { render } from "./Asa.vue?vue&type=template&id=1aabcb3e"
import script from "./Asa.vue?vue&type=script&lang=js"
export * from "./Asa.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__